var _path, _path2, _path3, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 276 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 51V225C7 249.301 26.6995 269 51 269H225C249.301 269 269 249.301 269 225V51C269 26.6995 249.301 7 225 7H51C26.6995 7 7 26.6995 7 51Z",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 80.7589V203.175C73.6253 222.965 79.9926 223.975 93.2591 222.572H179.899C197.2 224.072 203.357 220.922 203.606 203.175V80.7589C201.88 66.2657 191.819 64.0757 166.105 65.2413C166.105 110.932 104.897 107.484 108.346 65.2413C87.2809 63.8966 78.0595 65.7676 73 80.7589Z",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147 54H127V68.0794C132.217 78.8736 142 78.4042 147 68.0794V54Z",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 141,
    y1: 132,
    x2: 141,
    y2: 189,
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 158,
    x2: 170,
    y2: 158,
    stroke: "#8E8E8E",
    strokeWidth: 14
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.5d5698b8f6524720e6fc336fb13bad9b.svg";
export { ForwardRef as ReactComponent };